/**
 * Remove the end of a long string, replacing with '...'
 */
export const clampString = (text, maxChars, tail = '...') => {
    const previewText = text.substring(0, maxChars).trimEnd();
    return `${previewText}${text.length > maxChars ? tail : ''}`;
};
/**
 * Return a plural form of a string if a count is not equal 1.
 *
 * @example
 *
 * pluralize('creator');
 * //=> 'creators'
 *
 * pluralize('witch', 'es');
 * //=> 'witches'
 *
 * pluralize(['entry', 'entries']);
 * //=> 'entries'
 */
export const pluralize = (count, str, ending = 's') => {
    const singular = Array.isArray(str) ? str[0] : str;
    const plural = Array.isArray(str) ? str[1] : `${str}${ending}`;
    return 1 === count ? singular : plural;
};
